import React from "react";

/**
 * Renders an envelope icon as an SVG element.
 *
 * @param {string} cls - The class name for styling the SVG element.
 * @return {JSX.Element} The SVG element representing the envelope icon.
 */
export const EnvelopeIcon = ({ cls }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cls}
    >
      <g id="envelope (1) 2">
        <path
          id="Vector"
          d="M17.7273 3H6.27273C5.18816 3.0013 4.14837 3.43272 3.38146 4.19963C2.61455 4.96655 2.18312 6.00633 2.18182 7.09091L2.18182 16.9091C2.18312 17.9937 2.61455 19.0335 3.38146 19.8004C4.14837 20.5673 5.18816 20.9987 6.27273 21H17.7273C18.8119 20.9987 19.8516 20.5673 20.6186 19.8004C21.3855 19.0335 21.8169 17.9937 21.8182 16.9091V7.09091C21.8169 6.00633 21.3855 4.96655 20.6186 4.19963C19.8516 3.43272 18.8119 3.0013 17.7273 3ZM6.27273 4.63636H17.7273C18.2172 4.63733 18.6956 4.78488 19.101 5.06002C19.5063 5.33517 19.8201 5.72532 20.0018 6.18027L13.7362 12.4467C13.2751 12.906 12.6508 13.1638 12 13.1638C11.3492 13.1638 10.7249 12.906 10.2638 12.4467L3.99819 6.18027C4.17995 5.72532 4.49369 5.33517 4.89904 5.06002C5.3044 4.78488 5.78282 4.63733 6.27273 4.63636ZM17.7273 19.3636H6.27273C5.62175 19.3636 4.99742 19.105 4.53711 18.6447C4.07679 18.1844 3.81819 17.5601 3.81819 16.9091V8.31818L9.10691 13.6036C9.87488 14.3697 10.9153 14.7998 12 14.7998C13.0847 14.7998 14.1251 14.3697 14.8931 13.6036L20.1818 8.31818V16.9091C20.1818 17.5601 19.9232 18.1844 19.4629 18.6447C19.0026 19.105 18.3783 19.3636 17.7273 19.3636Z"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};
